import IconUser from "/svg/user.svg";
// import IconTasks from "/svg/list-check.svg";
import IconMatch from "/svg/cards.svg";
// import IconCommunity from "/svg/starRating.svg";
import IconReactions from "/svg/likeButton-gray.svg";

export const navLinks = [
  { isMainButton: false, path: "/match", icon: IconMatch, basePath: "/match" },

  {
    isMainButton: false,
    path: "/reactions/likes",
    icon: IconReactions,
    basePath: "/reactions",
  },
  // { isMainButton: false, path: "/community", icon: IconCommunity, basePath: "/community" },
  // { isMainButton: true, path: "", icon: "" },
  // { isMainButton: false, path: "/tasks", icon: IconTasks, basePath: "/tasks" },
  {
    isMainButton: false,
    path: "/profile",
    icon: IconUser,
    basePath: "/profile",
  },
];
